import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Box } from 'grommet/components/Box';
import { Text } from 'grommet/components/Text';
import { Button } from 'grommet/components/Button';
import { Anchor } from 'grommet/components/Anchor';
import { RadioButton } from 'grommet/components/RadioButton';
import { CheckBox } from 'grommet/components/CheckBox';
import { Layer } from 'grommet/components/Layer';
import Form from '../Components/Form.js';
import { POPUPEMAIL, POPUPREG } from '../Constants.js';


class DatiResponsabile extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            enabled: false
        }
        this.activeButton = this.activeButton.bind(this);
        this.disableButton = this.disableButton.bind(this);
    }

    saveAndContinue = (e) => {
        e.preventDefault()
        this.props.nextStep()
    }

    activeButton() {
        this.setState({
            enabled: true
        })
    }

    disableButton() {
        this.setState({
            enabled: false
        })
    }


    render() {
        const invioEmail = (<Layer
            flush={true}
            margin='medium'
            onClickOutside={this.props.closeModal}
            onEsc={this.props.closeModal}>
            <Box overflow='auto'>

                <Text className='titlehome titleModal'>
                    {POPUPEMAIL.title}
                    <button type="button" aria-label="Chiudi finestra" title="Chiudi" style={{ background: 'none', border: 'none', padding: 0, margin: 0, float: 'right', cursor: 'pointer' }} onClick={this.props.closeModal}>
  <i className='icon-close' aria-hidden="true" style={{ textAlign: 'right', fontSize: '15px', color: '#000000' }} />
</button>
                </Text>
                <Text className='subtitlehome subtitleModal' style={{ marginTop: '0' }}>
                    {POPUPEMAIL.text1}
                </Text>
                <Text className='subtitlehome textModal' style={{ marginTop: '10px' }}>
                    {POPUPEMAIL.text2}
                </Text>
            </Box>
        </Layer>
        )


        const modalRegolamento = (<Layer
            flush={true}
            margin='medium'
            onClickOutside={this.props.closeModal}
            onEsc={this.props.closeModal}>
            <Box overflow='auto'>

                <Text className='titlehome titleModal'>
                    {POPUPREG.title}
                    <button type="button" aria-label="Chiudi finestra" title="Chiudi" style={{ background: 'none', border: 'none', padding: 0, margin: 0, position: 'absolute', top: '12px', right: '25px', cursor: 'pointer' }} onClick={this.props.closeModal}>
  <i className='icon-close' aria-hidden="true" style={{ textAlign: 'right', fontSize: '15px', color: '#000000' }} />
</button>
                </Text>
                <Text className='subtitlehome subtitleModal'>
                    {POPUPREG.subtitle1}
                </Text>

                <Text className='subtitlehome textModal'>
                    {POPUPREG.paragraph1}
                </Text>
                <Text className='subtitlehome textModal'>
                    {POPUPREG.paragraph2}
                </Text>

                <Text className='subtitlehome subtitleModal'>
                    {POPUPREG.subtitle2}
                </Text>
                <Text className='subtitlehome textModal'>
                    {POPUPREG.paragraph3}
                </Text>
                <Text className='subtitlehome textModal'>
                    {POPUPREG.paragraph4}
                </Text>
                <Text className='subtitlehome textModal'>
                    {POPUPREG.paragraph5}
                </Text>
                <Text className='subtitlehome subtitleModal'>
                    {POPUPREG.subtitle3}
                </Text>
                <Text className='subtitlehome textModal'>
                    {POPUPREG.paragraph6}
                </Text>
                <Text className='subtitlehome subtitleModal'>
                    {POPUPREG.subtitle4}
                </Text>
                <Text className='subtitlehome textModal'>
                    {POPUPREG.paragraph7}
                </Text>
            </Box>
        </Layer>)

        return (
            <Box>
                <Box style={{ padding: '30px 20px 0 20px' }}>
                    <Text className='titleDispute'><h3>DATI DEL RESPONSABILE</h3></Text>
                </Box>
                <Box style={{ padding: '30px 50px 0 50px' }}>
                    <Box align='center'>
                        <Form codsocieta={this.props.values.codsocieta} nome={this.props.values.nome} cognome={this.props.values.cognome} telefono={this.props.values.telefono} fax={this.props.values.fax} email={this.props.values.email}
                            msgcodsoc={this.props.values.msgcodsoc} msgemail={this.props.values.msgemail} msgnumtel={this.props.values.msgnumtel} msgfax={this.props.values.msgfax} onChange={this.props.setForm}
                            activeButton={this.activeButton} disableButton={this.disableButton} />
                    </Box>
                </Box>





                {window.location.pathname === '/DisputeOnlineRegistered' ? <Box style={{ padding: '30px 20px 0 20px' }}> <Box align='center'>
                    <Button className='btnform' disabled={!this.state.enabled} style={{ width: '170px', marginBottom: '30px' }} onClick={this.saveAndContinue} aria-label="Prosegui al passo successivo per inserire dati gestore">Prosegui</Button>
                </Box></Box> :
                    <Box style={{ padding: '30px 20px 0 20px' }}>
                        <Text justify='left' className='subtitlehome'>Gli avvisi via e-mail saranno <span className='bold'>inviati automaticamente</span> al GESTORE. Se il GESTORE e il RESPONSABILE coincidono,
                                                                        verrà inviata una mail unica. <Anchor onClick={this.props.showModalemail}>Clicca qui</Anchor> per visualizzare i criteri di invio.</Text>
                        {this.props.values.openModalemail === true ? invioEmail : ''}<br />
                        <Box direction='row' style={{ marginBottom: '25px' }}>
                            <Text className='subtitlehome choice'>Come <span className='bold'>RESPONSABILE</span>, desidero ricevere <span className='bold'>copia degli avvisi</span> via e-mail inviati al <span className='bold'>GESTORE</span>.
                                <Box direction='row' className='nomargin'>
                                    <RadioButton id='yes' label='SI' className='radiobutton' checked={this.props.values.checked === 'Y'} onChange={this.props.setRadioButton} value='Y' />
                                    <RadioButton id='no' label='NO' className='radiobutton' checked={this.props.values.checked === 'N'} onChange={this.props.setRadioButton} value='N' />
                                </Box>
                            </Text>
                        </Box>
                        <Box className='subtitlehome' style={{ marginRight: '20px' }}>
                            <Anchor style={{ maxWidth: '150px' }} onClick={this.props.showModal}>Regolamento del servizio</Anchor>
                        </Box>
                        <Box direction='row' style={{ marginBottom: '50px' }}>
                            <Text className='subtitlehome' style={{ marginRight: '20px' }}>Ho preso visione del regolamento</Text>
                            {this.props.values.openModal === true ? modalRegolamento : ''}
                            <Box direction='row' className='nomargincheck'>
                                <CheckBox className='radiobutton' checked={this.props.values.checkedbox} onChange={this.props.setCheckbox} />
                            </Box>
                        </Box>
                        <Box align='center'>
                            <Button className='btnform' disabled={!(this.props.values.checkedbox && this.state.enabled)} style={{ width: '170px', marginBottom: '30px' }} onClick={this.saveAndContinue} aria-label="Prosegui al passo successivo per inserire dati gestore">Prosegui</Button>
                        </Box>
                    </Box>}
            </Box>

        )
    }
}
export default DatiResponsabile;